var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElement3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.68V2.65333C14.6667 1.71333 14.24 1.33333 13.18 1.33333H10.4867C9.42667 1.33333 9 1.71333 9 2.65333V5.67333C9 6.62 9.42667 6.99333 10.4867 6.99333H13.18C14.24 6.99999 14.6667 6.62 14.6667 5.68Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 13.18V10.4867C14.6667 9.42667 14.24 9 13.18 9H10.4867C9.42667 9 9 9.42667 9 10.4867V13.18C9 14.24 9.42667 14.6667 10.4867 14.6667H13.18C14.24 14.6667 14.6667 14.24 14.6667 13.18Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 5.68V2.65333C6.99999 1.71333 6.57333 1.33333 5.51333 1.33333H2.81999C1.75999 1.33333 1.33333 1.71333 1.33333 2.65333V5.67333C1.33333 6.62 1.75999 6.99333 2.81999 6.99333H5.51333C6.57333 6.99999 6.99999 6.62 6.99999 5.68Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 13.18V10.4867C6.99999 9.42667 6.57333 9 5.51333 9H2.81999C1.75999 9 1.33333 9.42667 1.33333 10.4867V13.18C1.33333 14.24 1.75999 14.6667 2.81999 14.6667H5.51333C6.57333 14.6667 6.99999 14.24 6.99999 13.18Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement3);
export default __webpack_public_path__ + "static/media/element-3.fd5050ca4ea18fcbe48d1ad9276f052a.svg";
export { ForwardRef as ReactComponent };